<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <CardFieldRow
        v-model="nirCompensationAgreement.commonWork.workName"
        label="Название темы исследования согласно Договору с СЗГМУ им. И.И. Мечникова"
        placeholder="Добавьте название темы"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.workName"
        @input="
          $v.nirCompensationAgreement.commonWork.workName.$touch()
          updateNirCompensationAgreement()
        "
      />

      <CardFieldRow
        v-model="nirCompensationAgreement.agreementNumber"
        label="Номер договора"
        placeholder="Добавьте номер договора"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.agreementNumber"
        @input="
          $v.nirCompensationAgreement.agreementNumber.$touch()
          updateNirCompensationAgreement()
        "
      />

      <CardDateRow
        v-model="nirCompensationAgreement.agreementDateFrom"
        label="Дата начала договора"
        placeholder="Добавьте дату начало договора"
        :disabled="isShowMode"
        :error-messages="errorMessages.agreementDateFrom"
        :required="!isShowMode"
        @input="
          $v.nirCompensationAgreement.agreementDateFrom.$touch()
          updateNirCompensationAgreement()
        "
      />

      <CardDateRow
        v-model="nirCompensationAgreement.agreementDateTo"
        label="Дата окончания договора"
        placeholder="Добавьте дату окончания договора"
        :disabled="isShowMode"
        :error-messages="errorMessages.agreementDateTo"
        :required="!isShowMode"
        hide-border-bottom
        @input="
          $v.nirCompensationAgreement.agreementDateTo.$touch()
          updateNirCompensationAgreement()
        "
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { checkDate, compareTwoDates } from '@/scripts/validation'
import { setValidateMessages } from '../../../scripts/validation'
import CardFieldRow from '../../ui/row/CardFieldRow'
import { mapGetters } from 'vuex'
import { workStatusList, workStatusListName } from '@/scripts/consts'
import { NirCompensationAgreement } from '@/models/works/NirCompensationAgreement'
import CardDateRow from '@/components/ui/row/CardDateRow.vue'

export default {
  components: { CardDateRow, CardFieldRow },
  props: {
    isShowMode: Boolean,
    selectedItem: Object,
    title: String
  },

  mounted() {
    this.updateInvalid()
  },

  data: () => ({
    nirCompensationAgreement: new NirCompensationAgreement()
  }),

  validations() {
    return {
      nirCompensationAgreement: {
        commonWork: {
          workName: { required }
        },
        agreementNumber: { required },
        agreementDateFrom: { required, checkDate },
        agreementDateTo: { required, checkDate, compareTwoDates }
      }
    }
  },

  computed: {
    ...mapGetters('user', ['isAdmin', 'isModerator', 'isModeratorNir']),
    ...mapGetters('dictionaries', ['yearList']),

    isWorkAccepted() {
      return [workStatusListName.Accepted].includes(workStatusList[this.nirCompensationAgreement.commonWork.status?.id])
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.nirCompensationAgreement.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.nirCompensationAgreement[key])
      })

      Object.keys(this.$v.nirCompensationAgreement.commonWork.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.nirCompensationAgreement.commonWork[key])
      })

      return allErrors
    }
  },

  methods: {
    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    },

    async updateNirCompensationAgreement() {
      this.$emit('update:selected-item', new NirCompensationAgreement(this.nirCompensationAgreement.getForAPI()))
      this.updateInvalid()
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.nirCompensationAgreement = new NirCompensationAgreement(val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
